"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.P1 = void 0;
/**
 * Class used by channels for dtermining segments. Segments are used by
 * clsChannelUtility to handle double-backed segments so that the lines
 * will not go off the display area.
 *
 *
 */
class P1 {
    start = 0;
    end_Renamed = 0;
}
exports.P1 = P1;
//# sourceMappingURL=P1.js.map